<template>
  <!-- 故障信息 -->
  <div class="card">
    <b-card-header class="border-0">
      <h5 class="card-title mb-0">故障信息</h5>
    </b-card-header>
    <b-card-body class="border-0 border-top">
      <div>
        <label class="mb-3">问题描述</label>
        <div class="problem-describtion text-color">
          {{ detail.content }}
        </div>
      </div>
      <div class="mt-5">
        <label class="mb-3">附件</label>
        <div class="d-flex">
          <span
            v-for="(img, index) in imgList"
            :key="index"
            class="img-list me-2"
          >
            <img :src="img" />
          </span>
        </div>
      </div>
    </b-card-body>
  </div>
  <!-- 设备信息 -->
  <div class="card" id="equipment-table">
    <b-card-header class="border-0 border-bottom mb-3">
      <h5 class="card-title mb-0">设备信息</h5>
    </b-card-header>
    <!-- 表单区域 -->
    <b-card-body style="max-height: 540px; overflow: auto">
      <div class="table-responsive">
        <table class="table align-middle table-nowrap mb-0">
          <thead class="table-light text-muted">
            <tr>
              <th
                class="sort"
                :data-sort="head"
                v-for="(head, h_index) in detailData.tableHead"
                :key="h_index"
              >
                {{ head }}
              </th>
            </tr>
          </thead>
          <tbody class="list form-check-all">
            <tr v-for="body of paginate(detailData.tableBody)" :key="body.id">
              <td>{{ body.equipment_type }}</td>
              <td>
                <a
                  href="javascript:;"
                  class="cursor-pointer"
                  @click="handlerJump(body.id)"
                  >{{ body.equipment_name }}</a
                >
              </td>
              <td>{{ body.equipment_num }}</td>
              <td>{{ body.equipment_head_num }}</td>
              <td>{{ body.open_time }}</td>
              <td>
                <span
                  :class="['badge', detailData.statusStyle[body.status].color]"
                >
                  {{ detailData.statusStyle[body.status].text }}
                </span>
              </td>
              <td>{{ body.manager }}</td>
              <td>{{ body.phone }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </b-card-body>
    <Pagination
      v-if="tab_info_length"
      v-model:page="page"
      v-model:perPage="perPage"
      :pages="pages"
      :prePageOption="prePageOption"
      :tab_info_length="tab_info_length"
      class="me-5 my-3"
    ></Pagination>
  </div>
  <!-- 保养套餐 -->
  <div class="card" id="maintain-table">
    <b-card-header class="border-0 border-bottom mb-3">
      <h5 class="card-title mb-0">保养套餐</h5>
    </b-card-header>
    <!-- 表单区域 -->
    <b-card-body style="max-height: 540px; overflow: auto">
      <div class="table-responsive">
        <table class="table align-middle table-nowrap mb-0">
          <thead class="table-light text-muted">
            <tr>
              <th
                class="sort"
                :data-sort="head"
                v-for="(head, h_index) in detailData.maintainHead"
                :key="h_index"
              >
                {{ head }}
              </th>
            </tr>
          </thead>
          <tbody class="list form-check-all">
            <tr
              v-for="(body, index) of paginate(detailData.maintainBody)"
              :key="body.id"
            >
              <td>{{ index }}</td>
              <td>
                <a
                  href="javascript:;"
                  class="cursor-pointer"
                  @click="handlerJump(body.id)"
                  >{{ body.equipment_head_num }}</a
                >
              </td>
              <td>{{ body.maintain_name }}</td>
              <td>{{ body.maintain_content }}</td>
              <td>{{ body.end_time }}</td>
              <td>
                <span
                  :class="['badge', detailData.statusStyle[body.status].color]"
                >
                  {{ detailData.statusStyle[body.status].text }}
                </span>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </b-card-body>
    <Pagination
      v-if="tab_info_length"
      v-model:page="page"
      v-model:perPage="perPage"
      :pages="pages"
      :prePageOption="prePageOption"
      :tab_info_length="tab_info_length"
      class="me-5 my-3"
    ></Pagination>
  </div>
</template>

<script>
import { detailData } from "../data.js";
import { getFileDetail } from "@/service/index.js";
import _ from "lodash";
export default {
  props: {
    detailInfo: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      /* 分页start */
      tab_info_length: 0,
      page: 1,
      perPage: 10,
      prePageOption: [10, 15, 30, 40, 50],
      pages: [],
      /* 分页end */
      detailData,
      detail: {},
      imgList: [],
    };
  },
  watch: {
    detailInfo: {
      handler(val) {
        if (val) {
          this.detail = _.cloneDeep(val);
          this.initFileList();
        }
      },
      deep: true,
    },
  },
  mounted() {
    this.setPages();
  },
  methods: {
    initFileList() {
      if (
        this.detailInfo &&
        this.detailInfo.attachment &&
        this.detailInfo.attachment.length > 0
      ) {
        this.detailInfo.attachment.forEach((attach) => {
          let pramas = {
            id__in: attach,
          };
          getFileDetail(pramas).then((res) => {
            if (res && res.payload && res.payload.results) {
              let results = res.payload.results;
              results.forEach((result) => {
                this.imgList.push(result.url);
              });
            }
          });
        });
      }
    },
    handlerJump(id) {
      /* todo jump to detail */
      console.log(id);
    },
    /* 设置分页选项 */
    setPages() {
      this.pages = [];
      this.tab_info_length = this.detailData.tableBody.length;
      let numberOfPages = Math.ceil(
        this.detailData.tableBody.length / this.perPage
      );
      for (let index = 1; index <= numberOfPages; index++) {
        this.pages.push(index);
      }
    },
    /* 筛选分页数据 */
    paginate(orders) {
      if (orders && orders.length) {
        let page = this.page;
        let perPage = this.perPage;
        let from = page * perPage - perPage;
        let to = page * perPage;
        return orders.slice(from, to);
      }
    },
  },
  components: {},
};
</script>

<style scoped lang="scss">
.card-body {
  font-size: 14px;
}
.problem-describtion {
  max-height: 60px;
  overflow: auto;
}
.img-list {
  width: 80px;
  height: 80px;
}

.text-color {
  color: #9599ad;
}
</style>
